import React, { useMemo } from 'react';
import { Button, Empty, List, Space, Tag } from 'antd';
import { LeftOutlined, PlusOutlined, RightOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { ESTADO_COLORS, formatHora } from './agendaConstants';

const AgendaCalendarioDiario = ({ reuniones, currentDate, onDateChange, onSelectReunion, onCreate }) => {
  const dayKey = currentDate.format('YYYY-MM-DD');

  const dayItems = useMemo(() => {
    return reuniones
      .filter((r) => String(r.fecha).slice(0, 10) === dayKey)
      .sort((a, b) => {
        const ta = String(a.horaInicio || '00:00').slice(0, 5);
        const tb = String(b.horaInicio || '00:00').slice(0, 5);
        return ta.localeCompare(tb);
      });
  }, [reuniones, dayKey]);

  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 12,
          flexWrap: 'wrap',
          gap: 8,
        }}
      >
        <Space>
          <Button
            icon={<LeftOutlined />}
            size="small"
            onClick={() => onDateChange(currentDate.subtract(1, 'day'))}
          />
          <span style={{ fontWeight: 600, color: '#198039', fontSize: 14 }}>
            {currentDate.format('dddd DD/MM/YYYY')}
          </span>
          <Button
            icon={<RightOutlined />}
            size="small"
            onClick={() => onDateChange(currentDate.add(1, 'day'))}
          />
          <Button size="small" onClick={() => onDateChange(dayjs())}>
            Hoy
          </Button>
        </Space>
        <Button type="primary" size="small" icon={<PlusOutlined />} onClick={() => onCreate(dayKey)}>
          Nueva reunión
        </Button>
      </div>

      {dayItems.length === 0 ? (
        <Empty description="Sin reuniones para este día" style={{ padding: '32px 0' }} />
      ) : (
        <List
          dataSource={dayItems}
          renderItem={(item) => (
            <List.Item
              style={{
                cursor: 'pointer',
                background: '#fff',
                border: '1px solid #d8e8dc',
                borderRadius: 6,
                marginBottom: 8,
                padding: '10px 14px',
              }}
              onClick={() => onSelectReunion(item)}
            >
              <List.Item.Meta
                title={
                  <Space>
                    <span style={{ fontWeight: 600, color: '#198039' }}>
                      {formatHora(item.horaInicio)}
                      {item.horaFin ? ` — ${formatHora(item.horaFin)}` : ''}
                    </span>
                    <Tag color={ESTADO_COLORS[item.estado]}>{item.estado}</Tag>
                  </Space>
                }
                description={
                  <div>
                    <div style={{ fontWeight: 500 }}>{item.cliente}</div>
                    {item.contacto && <div style={{ fontSize: 12 }}>Contacto: {item.contacto}</div>}
                    {item.producto && <div style={{ fontSize: 12 }}>Producto: {item.producto}</div>}
                  </div>
                }
              />
            </List.Item>
          )}
        />
      )}
    </div>
  );
};

export default AgendaCalendarioDiario;
